module.exports = __webpack_public_path__ + "static/bigcommerce_5-aa63d8158b7e964a77707f7faac4fd59.png";